const getDefaultState = () => ({
  seasons: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  suppliers: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  salesTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  season: {
    itemsError: undefined,
    itemsLoading: false,
    saveError: undefined,
    saveLoading: false,
    id: undefined,
    twentySupplierId: undefined,
    name: undefined,
    active: true,
    webActive: true,
    arrivalFrom: undefined,
    arrivalTo: undefined,
    commissionRatio: 0,
    contributionRatio: 0,
    bookDaysBeforeArrival: 0,
    priceAdjustmentValue: 1,
    netOrGross: 'gross',
    salesRule: 'booking',
    keyCardPrice: undefined,
    keyCardPaymentType: 'mandatory',
    informationText: null,
    supplier: undefined,
    personCategories: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiPassSeasonId: undefined,
        name: undefined,
        externalName: undefined,
        ageFrom: undefined,
        ageTo: undefined,
      },
    },
    pricePeriods: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newPeriodItem: {
        id: undefined,
        skiPassSeasonId: undefined,
        arrivalFrom: undefined,
        arrivalTo: undefined,
        prices: {},
      },
    },
    prices: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newPriceItem: {
        id: undefined,
        skiPassPersonCategoryId: undefined,
        days: undefined,
        price: undefined,
        commissionRatio: undefined,
        contributionRatio: undefined,
      },
    },
    discounts: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiPassSeasonId: undefined,
        bookFrom: undefined,
        bookTo: undefined,
        arrivalFrom: undefined,
        arrivalTo: undefined,
        percentage: undefined,
      },
      personCategories: {
        itemsLoading: false,
        itemsError: undefined,
        saveLoading: false,
        saveError: undefined,
      },
    },
    skiAreas: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      ids: [],
    },
    newSeasonItem: {
      itemsError: undefined,
      itemsLoading: false,
      saveError: undefined,
      saveLoading: false,
      id: undefined,
      twentySupplierId: undefined,
      name: undefined,
      active: true,
      webActive: true,
      arrivalFrom: undefined,
      arrivalTo: undefined,
      commissionRatio: 0,
      contributionRatio: 0,
      bookDaysBeforeArrival: 0,
      priceAdjustmentValue: 1,
      netOrGross: 'gross',
      salesRule: 'booking',
      keyCardPrice: undefined,
      keyCardPaymentType: 'mandatory',
      informationText: null,
      supplier: undefined,
    },
  },
  pickupPlaces: {
    loading: false,
    error: false,
    items: [],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/skipass/defaultState.js